<template lang="pug">
  v-dialog#pemegangModal(
    v-model="openModal",
    width="50%",
    :fullscreen="$vuetify.breakpoint.xsOnly"
  )
    v-form
      v-card(:height="modalHeightDynamic")
        v-card-title.headline.grey.lighten-2 Search Departmen
        v-card-text
          v-container
            v-layout(row, wrap)
              v-flex(xs8, sm8)
                br
                v-text-field(
                  ref="searchField"
                  label="Nama Departmen",
                  required,
                  v-model="department",
                  @keyup.enter="search",
                  :rules="rules"
                  autofocus="false"
                  :autofocus="false"
                  tabindex="-1"
                )
              v-flex(xs4, sm4)
                br
                br
                v-btn(color="blue darken-1", text, bottom, @click="search") Search
              v-flex(xs12, sm12)
                v-flex(xs12, sm12)
                  v-layout(row)
                    v-btn(
                      color="blue"
                      dark
                      depressed
                      class="pl-4 pr-4 ma-4"
                      @click="selectAll"
                    ) Pilih Semua

                    v-spacer

                    v-btn(
                      color="red darken-1"
                      dark
                      depressed
                      class="pl-4 pr-4 ma-4"
                      @click="deselectAll"
                    ) Hapus Semua

              v-flex(xs12, sm12)
                v-data-table(
                  :headers="tableData.headers",
                  :items="tableData.items",
                  :items-per-page="5"
                )
                  template(v-slot:item.actions="{ item }")
                    v-checkbox(
                      :input-value="isSelected(item.name)",
                      @change="toggleSelection(item.name)"
                      style="margin-top: 10px; margin-bottom: -10px"
                    )
        v-card-actions
          v-spacer
          v-btn(color="blue darken-1", text, @click="closingModal") Close
          v-btn(color="blue darken-1", text, @click="saveData") SELECT
  </template>
  
  <script>
  import { mapState } from "vuex";
  import axios from "axios";
  export default {
    name: "ModalDepartment",
    components: {},
    props: ['departmentData', 'openModal'],
    mounted() {
      this.selected = this.departmentData; // Initialize selected with departmentData
      this.modalHeightDynamic = false;
      this.fetchDepartmentData(); // Fetch data from API
    },
    watch: {
      selected() {
        // Force the table to re-render when selections change
        this.$nextTick(() => {
          this.$refs.dataTable?.updatePagination();
        });
      },
      openModal(newVal) {
        if (newVal) {
          // When the modal opens, blur the search field to prevent auto-focus & set default department
          setTimeout(() => {
            this.tableData.items = this.departmentData.map(data =>{
              return {name : data}
            })
            this.selected = this.departmentData;
            this.$refs.searchField?.blur();
          }, 100); // Use a timeout to ensure the DOM is updated
        }
      },
    },
    data() {
      return {
        selected: [],
        department: "",
        modalHeight: "",
        dataSearch: [],
        tableData: {
          headers: [
            { text: "Nama Departmen", value: "name", width: "95%" },
            { text: "Action", value: "actions" },
          ],
          items: [],
        },
        rules: [
          (value) =>
            (value && value.length >= 2) || 'Min 2 characters' || !this.searchBTn.input-value
        ],
        selectAllCheckbox: false,
      };
    },
    computed: {
      ...mapState(["API_URL", "tokenIsafe"]),
      modalHeightDynamic: {
        get() {
          return this.modalHeight;
        },
        set(val) {
          const delta = this.dynamicHeight(val);
          this.modalHeight = delta;
        },
      },
      selectAllLabel() {
        return this.allChecked ? "Hapus Semua" : "Pilih Semua";
      },
      allChecked() {
        return this.dataSearch.length > 0 &&
          this.dataSearch.every(item => this.selected.includes(item.name));
      },
    },
    methods: {
      fetchDepartmentData() {
        axios({
          method: "get",
          url: `${this.API_URL}/form/getIsafeDepartment`,
          headers: { Authorization: `Bearer ${this.tokenIsafe}` },
        })
          .then((response) => {
            this.dataSearch = response.data.data;
            this.tableData.items = this.departmentData.map(data =>{
              return {name : data}
            })
            // Check items in departmentData by default
            this.selected = this.departmentData;
            // Blur the search field after data is fetched
            setTimeout(() => {
              this.$refs.searchField?.blur();
            }, 100); // Use a timeout to ensure the DOM is updated
          })
          .catch((error) => {
            console.log(error);
          });
      },
      dynamicHeight(search) {
        const isMobile = this.$vuetify.breakpoint.xsOnly;
        const mobileHeight = this.$vuetify.breakpoint.height;
        if (search) {
          if (this.tableData.items.length < 3) {
            return mobileHeight;
          }
          return "";
        }
        if (isMobile) {
          return `${mobileHeight}`;
        }
        return "";
      },
      search() {
        if (this.department.length >= 2) {
          const keyword = this.department.toLowerCase();
          this.tableData.items = this.dataSearch.filter(data =>
            data.name.toLowerCase().includes(keyword)
          );
        }
      },
      saveData() {
        this.$emit("selectedDepartment", this.selected);
        this.$emit("closeModal", false);
      },
      closingModal() {
        this.selected = this.departmentData;
        this.tableData.items = this.dataSearch.map(item => ({ name: item.name })); // Reset table to full dataset
        this.department = '';
        this.$emit("closeModal", false);
      },
      selectAll(){
        this.selected = this.dataSearch.map(item => item.name);
        this.tableData.items = this.dataSearch.map(item => ({ name: item.name }));
        this.selectAllCheckbox = true;
      },
      deselectAll(){
        this.selected = [];
        this.selectAllCheckbox = false;
      },
      toggleSelectAll() {
        if (this.allChecked) {
          // Deselect all items in the entire dataset
          this.selected = [];
        } else {
          // Select all items in the entire dataset
          this.selected = this.dataSearch.map(item => item.name);
        }
        this.selectAllCheckbox = !this.selectAllCheckbox;
      },
      isSelected(itemName) {
        return this.selected.includes(itemName);
      },
      toggleSelection(itemName) {
        if (this.selected.includes(itemName)) {
          // Deselect
          this.selected = this.selected.filter(item => item !== itemName);
        } else {
          // Select
          this.selected.push(itemName);
        }
      },
    },
  };
  </script>

  
  <style scoped>
  /* Class for the 'Pilih Semua' (Select All) button */
.select-button-left {
  color:white;
  border-radius: 15px 0 0 15px; /* Border-radius for top-left and bottom-left corners */
  margin-right: -1px; /* Remove space between the two buttons */
}

/* Class for the 'Hapus Semua' (Deselect All) button */
.select-button-right {
  color:white;
  border-radius: 0 15px 15px 0; /* Border-radius for top-right and bottom-right corners */
  margin-left: -1px; /* Remove space between the two buttons */
}
  .print-bg {
    background: rgb(204, 204, 204);
    padding-top: 10px;
  }
  .print-bg > div {
    text-align: center;
  }
  .page {
    background: white;
    display: block;
    margin: 5px auto;
    padding: 0.7cm 1cm 0.8cm;
    position: relative;
  }
  .page[size="A4"] {
    width: 21cm;
    height: 29.7cm;
  }
  .page[size="Auto"] {
    width: auto;
    margin: 0 auto;
    display: inline-block;
    text-align: initial;
  }
  .view-width {
    width: 11.3cm;
  }
  .print-header {
    border-collapse: collapse;
    text-align: right;
  }
  .padding-x-3 {
    padding: 0 3px;
  }
  .padding-xy-5 {
    padding: 2px;
  }
  .padding-xy-1 {
    padding: 1px;
  }
  .margin-tl-5 {
    margin: 3px 5px 0 5px;
  }
  .margin-tl-10 {
    margin: 3px 10px 0 10px;
  }
  .margin-tl-25 {
    margin: 3px 15px 0 25px;
  }
  .logo-cell {
    padding: 8px 5px 0px;
    width: 35%;
  }
  .detail-wrap {
    margin-top: 5px;
  }
  .border-left-0 {
    border-left: 0;
  }
  .border-right-0 {
    border-right: 0;
  }
  .approved {
    text-align: center;
    padding: 5px;
  }
  .ff0000 {
    color: #ff0000;
  }
  .align-center {
    text-align: center;
  }
  .align-left {
    align-items: left;
  }
  .width-20p {
    width: 20%;
  }
  .width-25p {
    width: 25%;
  }
  .height-40px {
    height: 40px;
  }
  .width-300px {
    width: 250px;
  }
  .top-align {
    vertical-align: top;
  }
  .navFixed {
    position: fixed;
    z-index: 9;
  }
  .padTop60 {
    padding-top: 60px;
  }
  .blink {
    -webkit-animation: blink 2s steps(5, start) infinite;
    animation: blink 2s steps(5, start) infinite;
    color: #dddddd;
  }
  @-webkit-keyframes blink {
    to {
      color: #ffffff;
    }
  }
  @keyframes blink {
    to {
      color: #ffffff;
    }
  }
  @media print {
  }
  table {
    border-collapse: collapse;
  }
  .headerTable {
    border: 1px solid black;
    background-color: #cccccc;
  }
  .tableInput td {
    border: 1px solid black;
    padding-left: 5px;
  }
  .verMiddle {
    vertical-align: middle;
  }
  </style>